import { Injectable, inject } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { map, Observable } from 'rxjs'
import { environment } from 'src/environments/environment'
import { ApiResponse } from 'src/app/shared/interfaces/api-response/api-response.interface'

export interface AiTextGenerationResponse {
    content: string
    agentName: string
}

@Injectable({
    providedIn: 'root',
})
export class AiRewriteService {
    #http = inject(HttpClient)
    #apiUrl = `${environment.baseUrl}ai/agent/rewrite`

    generateText(prompt: string, style: 1 | 2 | 3 = 1, instructions?: string): Observable<AiTextGenerationResponse> {
        return this.#http
            .get<
                ApiResponse<AiTextGenerationResponse>
            >(`${this.#apiUrl}?prompt=${prompt}&style=${style}&instructions=${instructions}`)
            .pipe(map((response) => response.result))
    }
}
